import { observer } from "mobx-react-lite";
import React from "react";
import { CcV4Toggle } from "../UI/CcV4Toggle";

export const ItemRight = observer((props) => {
  return (
    <li>
      <label className="flx-sb mrg-btm-10 ">
        <span className="role_item_text">
          {props.right.name_rights === "get_pin_id"
            ? "Получить / проверить лицензии компании"
            : props.right.name_rights === "post_generate"
              ? "Создать /привязать / продлить лицензию"
              : props.right.name_rights === "patch_unlink"
                ? "Отвязать/активировать/деактивировать лицензию"
                : props.right.name_rights === "post_company"
                  ? "Добавить новую компанию"
                  : props.right.name_rights === "get_all_company"
                    ? "Получить компании"
                    : props.right.name_rights === "get_company_partners"
                      ? "Получить партнёров"
                      : props.right.name_rights === "post_company_partner_link"
                        ? "Создать связь партнёр–клиент"
                        : props.right.name_rights === "patch_company_partner_link"
                          ? "Изменить связь партнёр–клиент"
                          : props.right.description_rights}
        </span>
        <CcV4Toggle
          onClick={() => props.actionRole(props.right)}
          active={props.right.activ}
        />
      </label>
    </li>
  );
});
